/**
 * Migration time (Y) is stored in years for the time tests (D + Y > Z) and shown and entered in months.
 */
export const monthsOf = (years: number) => Math.max(0, Math.round(years * 12));
export const yearsOfMonths = (months: number) => Math.round((months / 12) * 100) / 100;

export function monthsText(years: number): string {
  const m = monthsOf(years);
  return m < 1 ? "under a month" : `${m} month${m === 1 ? "" : "s"}`;
}
